import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import {
  TextField,
  Button,
  Grid,
  Divider,
  Box,
  MenuItem,
  Tooltip,
  Toolbar,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import ImageWithDeleteButton from "../../Update_Campaign/comman/imageContainer";
import { uploadImage } from "../../../redux/actions/addCampaigndata";
import { useDispatch, useSelector } from "react-redux";
import {
  getHeaderData,
  headerAi,
  updateHeaderAi,
} from "../../../redux/actions/ai_functions";
import { left } from "@popperjs/core";
import {
  Add,
  ArrowDownward,
  CheckBox,
  Delete,
  ExpandLess,
  ExpandMore,
  Star,
  StarRate,
} from "@mui/icons-material";
import { forEach } from "lodash";

const DynamicForm = ({ handleNext, validationHeaderSchema, activeStep }) => {
  const [navLeftCollapsed, setNavLeftCollapsed] = useState(true);
  const [navListCollapsed, setNavListCollapsed] = useState(true);
  const [shareImageCollapsed, setShareImageCollapsed] = useState(true);
  const [seoDataCollapsed, setSeoDataCollapsed] = useState(true);
  const {
    createAiHeaderData,
    headerDataForParticular,
    updatedAiHeaderData,
    ongoing_ai_id,
  } = useSelector((state) => state?.aiDataReducer);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationHeaderSchema),
    defaultValues: {
      nav_left_logo: {
        image: null,
        link: "",
        alt: "",
        target: "",
      },
      nav_lists: headerDataForParticular?.nav_lists || [
        {
          text: "",
          link: "",
          target: "",
          order: null,
        },
      ],
      agent_id: "",
      seo_title: "",
      seo_description: "",
      seo_keywords: "",
      seoDone: false,
      share_image: { image: null },
      share_title: "",
      share_description: "",
      favicon: { image: null },
      created_by: "",
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "nav_lists",
  });

  const dispatch = useDispatch();

  const handleImage = async (logo, e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) {
      setError(`${logo}.file`, {
        type: "manual",
        message: "Invalid file type. Please select a valid image.",
      });
      return;
    }

    clearErrors(`${logo}.file`);
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await dispatch(uploadImage(formData));
      setValue(`${logo}.image`, res);
    } catch (err) {
      console.error(err);
    }
  };

  console.log(errors, "errors");

  const onSubmit = (data) => {
    try {
      const recreatedSchema = {
        nav_left_logo: data.nav_left_logo,
        nav_lists: data.nav_lists,
        agent_id: data.agent_id,
        seo_title: data.seo_title,
        seo_keywords: data.seo_keywords,
        seo_description: data.seo_description,
        share_description: data.share_description,
        share_image: data.share_image.image,
        share_title: data.share_title,
        favicon: data.favicon.image,
        seoDone: data.seoDone,
      };

      if (headerDataForParticular?.created_by) {
        dispatch(updateHeaderAi(recreatedSchema));
      } else {
        dispatch(headerAi(recreatedSchema));
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (updatedAiHeaderData && localStorage.getItem("isHeaderUpdated")) {
      handleNext();
      localStorage.removeItem("isHeaderUpdated");
    }
  }, [updatedAiHeaderData]);

  useEffect(() => {
    if (createAiHeaderData && localStorage.getItem("isHeaderCreated")) {
      handleNext();
      localStorage.removeItem("isHeaderCreated");
    }
  }, [createAiHeaderData]);

  useEffect(() => {
    if (headerDataForParticular?.nav_lists) {
      headerDataForParticular?.nav_lists?.forEach((listItem, index) => {
        setValue(`nav_lists[${index}].text`, listItem?.text);
        setValue(`nav_lists[${index}].link`, listItem?.link);
        setValue(`nav_lists[${index}].target`, listItem?.target);
        setValue(`nav_lists[${index}].order`, listItem?.order);
      });
    }

    // Set other values for non-array fields
    setValue(
      "nav_left_logo.image",
      headerDataForParticular?.nav_left_logo?.image
    );
    setValue("nav_left_logo.alt", headerDataForParticular?.nav_left_logo?.alt);
    setValue(
      "nav_left_logo.link",
      headerDataForParticular?.nav_left_logo?.link
    );
    setValue(
      "nav_left_logo.target",
      headerDataForParticular?.nav_left_logo?.target
    );
    setValue("agent_id", headerDataForParticular?.agent_id || ongoing_ai_id);
    setValue("seo_description", headerDataForParticular?.seo_description);
    setValue("seo_title", headerDataForParticular?.seo_title);
    setValue("seoDone", headerDataForParticular?.seoDone);
    setValue("seo_keywords", headerDataForParticular?.seo_keywords);
    setValue("share_description", headerDataForParticular?.share_description);
    setValue("share_image.image", headerDataForParticular?.share_image);
    setValue("share_title", headerDataForParticular?.share_title);
    setValue("favicon.image", headerDataForParticular?.favicon);
  }, [headerDataForParticular, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container columnSpacing={0} sx={{ paddingY: "2rem",display:"flex",justifyContent:'space-around' }}>
        <Grid item xs={12} md={5} className="p-0">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: "10px",
              border: navLeftCollapsed ? "" : "1px solid green",
              borderRadius: "10px",
              gap: "10px",
            }}
          >
            <div
              className="w-100 text-center"
              style={{
                display: "flex",
                border: errors?.nav_left_logo?.image
                  ? "2px solid red"
                  : "2px solid green",
                width: "100%",
                padding: "8px",
                margin: "0px auto",
                borderRadius: "8px",
                cursor: "pointer",
                justifyContent: "space-between",
              }}
              onClick={() => {
                if (navLeftCollapsed) {
                  setNavLeftCollapsed(false);
                } else {
                  setNavLeftCollapsed(true);
                }
              }}
            >
              <StarRate className="text-success" />
              <span>Nav Left Logo</span>
              {navLeftCollapsed ? (
                <ExpandLess className="text-success" />
              ) : (
                <ExpandMore className="text-success" />
              )}
            </div>
            <div
              style={{
                display: navLeftCollapsed ? "none" : "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    // margin: "8px 0px",
                  }}
                >
                  <Button
                    variant="contained"
                    component="label"
                    color={errors?.nav_left_logo?.image ? "error" : "success"}
                    style={{ height: "fit-content", width: "fit-content" }}
                  >
                    Nav left Logo
                    <input
                      type="file"
                      hidden
                      onChange={(e) => {
                        handleImage("nav_left_logo", e);
                        clearErrors("nav_left_logo.image");
                      }}
                    />
                  </Button>

                  <ImageWithDeleteButton
                    logoName="nav_left_logo.image"
                    watch={watch}
                    setValue={setValue}
                  />
                </Box>
                {errors?.nav_left_logo?.image && (
                  <span className="text-danger">
                    {errors?.nav_left_logo?.image?.message}
                  </span>
                )}
              </div>
              <Box style={{ width: "100%" }}>
                <Controller
                  name="nav_left_logo.link"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Link"
                      {...field}
                      error={!!errors.nav_left_logo?.link}
                      helperText={errors.nav_left_logo?.link?.message || ""}
                      margin="normal"
                      className="w-100"
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Controller
                  name="nav_left_logo.alt"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Alt Text"
                      {...field}
                      error={!!errors.nav_left_logo?.alt}
                      helperText={errors.nav_left_logo?.alt?.message || ""}
                      margin="normal"
                      className="w-50"
                    />
                  )}
                />
                <Controller
                  name="nav_left_logo.target"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Target"
                      select
                      margin="normal"
                      className="w-50"
                      error={!!errors.nav_left_logo?.target}
                      helperText={errors.nav_left_logo?.target?.message || ""}
                    >
                      <MenuItem value="_self">_self</MenuItem>
                      <MenuItem value="_blank">_blank</MenuItem>
                    </TextField>
                  )}
                />
              </Box>
            </div>
          </div>
          <Divider className="my-3 bg-success" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              padding: "10px",
              border: navListCollapsed ? "" : "1px solid green",
              borderRadius: "10px",
              gap: "10px",
            }}
          >
            <div
              className="w-100 text-center"
              style={{
                border: errors?.nav_lists ? "2px solid red" : "2px solid green",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                padding: "8px",
                margin: "0px auto",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={() => {
                if (navListCollapsed) {
                  setNavListCollapsed(false);
                } else {
                  setNavListCollapsed(true);
                }
              }}
            >
              <StarRate className="text-success" />
              <span>Create Nav List</span>
              {navListCollapsed ? (
                <ExpandLess className="text-success" />
              ) : (
                <ExpandMore className="text-success" />
              )}
            </div>
            <div
              style={{
                display: navListCollapsed ? "none" : "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {fields?.map((item, index) => (
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  key={item.id}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "20px",
                    }}
                  >
                    <Controller
                      name={`nav_lists[${index}].text`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Alt text"
                          margin="normal"
                          className="w-50"
                          error={
                            errors.nav_lists && errors?.nav_lists[index]?.text
                          }
                          helperText={
                            (errors?.nav_lists &&
                              errors.nav_lists[index]?.text?.message) ||
                            ""
                          }
                        />
                      )}
                    />
                    <Controller
                      name={`nav_lists[${index}].link`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Link"
                          {...field}
                          error={
                            errors.nav_lists && errors.nav_lists[index]?.link
                          }
                          helperText={
                            (errors.nav_lists &&
                              errors.nav_lists[index]?.link?.message) ||
                            ""
                          }
                          margin="normal"
                          className="w-50"
                        />
                      )}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "20px",
                    }}
                  >
                    <Controller
                      name={`nav_lists[${index}].target`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label="Target"
                          select
                          margin="normal"
                          className="w-50"
                          error={
                            errors.nav_lists && errors.nav_lists[index]?.target
                          }
                          helperText={
                            (errors.nav_lists &&
                              errors.nav_lists[index]?.target?.message) ||
                            ""
                          }
                        >
                          <MenuItem value="_self">_self</MenuItem>
                          <MenuItem value="_blank">_blank</MenuItem>
                        </TextField>
                      )}
                    />
                    <Controller
                      name={`nav_lists[${index}].order`}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="number"
                          select
                          label="Order"
                          value={field.value || ""}
                          margin="normal"
                          className="w-50"
                          error={
                            errors.nav_lists && errors.nav_lists[index]?.order
                          }
                          helperText={
                            (errors.nav_lists &&
                              errors.nav_lists[index]?.order?.message) ||
                            ""
                          }
                        >
                          {[...Array(15).keys()].map((number) => (
                            <MenuItem
                              key={number + 1}
                              value={(number + 1).toString()}
                            >
                              {number + 1}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    />
                  </Box>
                  <div className="column d-flex justify-content-end m-2">
                    {fields.length > 0 && (
                      <Tooltip title="Delete" arrow>
                        <Delete
                          onClick={() => remove(index)}
                          style={{ color: "red", cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}
                  </div>
                </div>
              ))}
              <Toolbar className="p-0">
                <Tooltip title="Add" arrow>
                  <Button
                    className="button "
                    variant="outlined"
                    disableElevation
                    startIcon={<Add />}
                    onClick={(e) => {
                      e.preventDefault();
                      append({ text: "", link: "", target: "", order: null });
                    }}
                  >
                    Add
                  </Button>
                </Tooltip>
              </Toolbar>
            </div>
          </div>
          <Divider className="my-3 bg-success" />
        </Grid>
        <Grid item xs={12} md={5} mt={0}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: "10px",
              padding: "10px",
              border: seoDataCollapsed ? "" : "1px solid green",
              borderRadius: "10px",
            }}
          >
            <div
              className="w-100 text-center"
              style={{
                border:
                  errors?.seo_description ||
                  errors?.seo_keywords ||
                  errors?.seo_title ||
                  errors?.favicon
                    ? "2px solid red"
                    : "2px solid green",
                display: "flex",
                width: "100%",
                padding: "8px",
                margin: "0px auto",
                borderRadius: "8px",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick={() => {
                if (seoDataCollapsed) {
                  setSeoDataCollapsed(false);
                } else {
                  setSeoDataCollapsed(true);
                }
              }}
            >
              <StarRate className="text-success" />
              <span>Create Seo Data </span>
              {seoDataCollapsed ? (
                <ExpandLess className="text-success" />
              ) : (
                <ExpandMore className="text-success" />
              )}
            </div>
            <div
              style={{
                display: seoDataCollapsed ? "none" : "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <Button
                    variant="contained"
                    component="label"
                    color={errors?.favicon?.image ? "error" : "success"}
                    style={{ height: "fit-content", width: "fit-content" }}
                  >
                    Favicon
                    <input
                      type="file"
                      hidden
                      onChange={(e) => {
                        handleImage("favicon", e);
                        clearErrors("favicon.image");
                      }}
                    />
                  </Button>
                  <ImageWithDeleteButton
                    logoName="favicon.image"
                    watch={watch}
                    setValue={setValue}
                  />
                </Box>
                {errors?.favicon && (
                  <span className="fs-6 text-danger">
                    {errors?.favicon?.image?.message}
                  </span>
                )}
              </div>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Controller
                  name="seo_title"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Seo Title"
                      {...field}
                      error={!!errors?.seo_title}
                      helperText={errors?.seo_title?.message || ""}
                      margin="normal"
                      className="w-100"
                    />
                  )}
                />
                <Controller
                  name="seo_keywords"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Seo Keywords"
                      {...field}
                      error={!!errors?.seo_keywords}
                      helperText={errors?.seo_keywords?.message || ""}
                      margin="normal"
                      className="w-100"
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Controller
                  name="seo_description"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Seo Description"
                      {...field}
                      error={!!errors?.seo_description}
                      helperText={errors?.seo_description?.message || ""}
                      margin="normal"
                      className="w-100"
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Controller
                  name="seoDone"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={<Checkbox {...field} checked={field?.value} />}
                      label="Seo Data Done"
                    />
                  )}
                />
              </Box>
            </div>
          </div>
          <Divider className="my-3 bg-success" />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "10px 0px",
              gap: "20px",
              padding: "10px",
              border: shareImageCollapsed ? "" : "1px solid green",
              borderRadius: "10px",
            }}
          >
            <div
              className="w-100 text-center"
              style={{
                border:
                  errors?.share_description ||
                  errors?.share_image?.image ||
                  errors?.share_title
                    ? "2px solid red"
                    : "2px solid green",
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                padding: "8px",
                margin: "0px auto",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={() => {
                if (shareImageCollapsed) {
                  setShareImageCollapsed(false);
                } else {
                  setShareImageCollapsed(true);
                }
              }}
            >
              <StarRate className="text-success" />
              <span>Create Share Image </span>
              {shareImageCollapsed ? (
                <ExpandLess className="text-success" />
              ) : (
                <ExpandMore className="text-success" />
              )}
            </div>
            <div
              style={{
                display: shareImageCollapsed ? "none" : "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "20px",
                  }}
                >
                  <Button
                    className="w-50"
                    variant="contained"
                    color={errors?.share_image ? "error" : "success"}
                    component="label"
                    style={{ height: "fit-content" }}
                  >
                    Share Image
                    <input
                      type="file"
                      hidden
                      onChange={(e) => {
                        handleImage("share_image", e);
                        clearErrors("share_image.image");
                      }}
                    />
                  </Button>
                  <ImageWithDeleteButton
                    logoName="share_image.image"
                    watch={watch}
                    setValue={setValue}
                  />
                </Box>
                {errors?.share_image && (
                  <span className="text-danger">
                    {errors?.share_image?.image?.message}
                  </span>
                )}
              </div>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                <Controller
                  name="share_title"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Share Title"
                      {...field}
                      error={!!errors?.share_title}
                      helperText={errors?.share_title?.message || ""}
                      margin="normal"
                      className="w-100"
                    />
                  )}
                />
                <Controller
                  name="share_description"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="Share Description"
                      {...field}
                      error={!!errors?.share_description}
                      helperText={errors?.share_description?.message || ""}
                      margin="normal"
                      className="w-100"
                    />
                  )}
                />
              </Box>
            </div>
          </div>
          <Box sx={{ paddingX: "1rem" }}>
            <Controller
              name="agent_id"
              control={control}
              render={({ field }) => (
                <TextField
                  label={"Agent ID"}
                  {...field}
                  InputProps={{
                    readOnly: true,
                  }}
                  error={!!errors?.agent_id}
                  helperText={errors?.agent_id?.message || ""}
                  margin="normal"
                  className="w-50"
                >
                  {field.value}
                </TextField>
              )}
            />
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Button variant="contained" type="submit">
          Submit
        </Button>
      </Box>
    </form>
  );
};

export default DynamicForm;
